export const SEVERITY_STYLES = {
  critical: 'bg-red-100 text-red-700 border-red-200',
  warning: 'bg-amber-100 text-amber-700 border-amber-200',
  info: 'bg-blue-100 text-blue-700 border-blue-200',
};

export const ALERT_STATUS_STYLES = {
  open: 'bg-red-100 text-red-700',
  acknowledged: 'bg-amber-100 text-amber-700',
  resolved: 'bg-emerald-100 text-emerald-700',
};

export const ALERT_TYPE_LABELS = {
  offline: 'Device Offline',
  high_cpu: 'High CPU',
  high_ram: 'High RAM',
  low_disk: 'Low Disk',
  site_outage: 'Site Outage',
  service_down: 'Service Down',
  vm_down: 'VM Down',
  host_down: 'Hyper-V Host Down',
  ping_down: 'Unreachable',
  high_latency: 'High Latency',
  packet_loss: 'Packet Loss',
  port_down: 'Port Down',
  snmp_fail: 'SNMP Failure',
  wan_outage: 'WAN Outage',
  website_down: 'Website Down',
  dns_failure: 'DNS Failure',
  ssl_expiring: 'SSL Expiring',
};

export const fmtWhen = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 90) return 'just now';
  if (diff < 3600) return `${Math.round(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.round(diff / 3600)}h ago`;
  return d.toLocaleDateString() + ' ' + d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

export const fmtUptime = (secs) => {
  if (secs == null) return '—';
  const days = Math.floor(secs / 86400);
  const hrs = Math.floor((secs % 86400) / 3600);
  return days > 0 ? `${days}d ${hrs}h` : `${hrs}h ${Math.floor((secs % 3600) / 60)}m`;
};

export const pctColor = (v) => {
  if (v == null) return 'text-slate-400';
  if (v >= 90) return 'text-red-600 font-semibold';
  if (v >= 80) return 'text-amber-600 font-semibold';
  return 'text-slate-700';
};
